import React from 'react';
import { connect } from 'react-redux';
import { Input } from 'reactstrap';

interface UserBrand {
  _id: string;
  name: string;
}

interface Collection {
  userBrand?: string;
}

interface DefaultUserBrand {
  _id?: string;
}

interface UserBrandSelectionOwnProps {
  onChange: (value: string) => void;
  collection?: Collection;
  selectedUserBrand?: string;
}

interface UserBrandSelectionStateProps {
  userBrands: { [key: string]: UserBrand };
  defaultUserBrand: DefaultUserBrand | string;
}

type UserBrandSelectionProps = UserBrandSelectionOwnProps & UserBrandSelectionStateProps;

const UserBrandSelection: React.FC<UserBrandSelectionProps> = ({
  userBrands,
  onChange,
  defaultUserBrand,
  collection,
  selectedUserBrand
}) => (
  <Input
    type="select"
    onChange={({ target: { value } }) => onChange(value)}
    value={
      (collection && collection.userBrand) ||
      selectedUserBrand ||
      (typeof defaultUserBrand === 'object' ? defaultUserBrand._id : defaultUserBrand) ||
      ''
    }
  >
    {Object.keys(userBrands).map(
      (key) =>
        userBrands[key] &&
        userBrands[key]._id && (
          <option key={key} value={userBrands[key]._id}>
            {userBrands[key].name}
          </option>
        )
    )}
  </Input>
);

interface StateProps {
  userBrands: { [key: string]: UserBrand };
  auth: {
    defaultUserBrand: DefaultUserBrand | string;
  };
}

function mapStateToProps({ userBrands, auth: { defaultUserBrand } }: StateProps) {
  return { userBrands, defaultUserBrand };
}

export default connect(mapStateToProps, null)(UserBrandSelection);
